import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
  ContainerRoot: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  root: {
    display: 'flex',
    flexDirection: 'column'
  },
  buttons: {
    height: 44,
    letterSpacing: 1.25,
    fontSize: 16,
    fontWeight: '400',
    minWidth: 'unset'
  },
  outlined: {
    background: '#FFFFFF',
    fontWeight: '500',
    '&:hover': {
      background: '#FFFFFF',
      opacity: 0.8
    },
    '&:focus': {
      background: '#FFFFFF',
      opacity: 0.8
    }
  },
  search: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '6px 16px',
    width: '70vh',
    border: '1px solid #EEEEEE'
  },
  icon: {
    fill: theme.palette.primary.main
  },
  input: {
    width: '100%'
  },
  horizontalPadding: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(3)
  },
  actionsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    backgroundColor: 'red'
  },
  pendingFieldCell: {
    borderRadius: '4px',
    textAlign: 'center',
    width: '30px',
    height: '30px',
    padding: 'auto',
    color: theme.palette.secondary.main
  },
  filters: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3)
  },
  filterField: {
    width: 200,
    '& .MuiInputBase-root': {
      height: 44,
      background: '#FFFFFF'
    }
  },
  searchSlot: {
    // SearchBarByType hardcodes its own left margin for the layouts it was
    // built for; here it is the first item of the row.
    '& .MuiPaper-root': {
      marginLeft: 0
    }
  },
  spacer: {
    flexGrow: 1
  },
  monthChip: {
    display: 'flex',
    alignItems: 'center',
    height: 44,
    padding: theme.spacing(0, 0.5),
    background: '#FFFFFF',
    border: '1px solid #EEEEEE',
    borderRadius: 4
  },
  monthArrow: {
    color: theme.palette.primary.main,
    padding: theme.spacing(0.5)
  },
  monthField: {
    width: 150,
    '& input': {
      textAlign: 'center',
      fontSize: 15,
      fontWeight: 500,
      color: theme.palette.primary.main,
      cursor: 'pointer',
      textTransform: 'capitalize'
    }
  },
  clearButton: {
    height: 44,
    padding: '0 24px',
    letterSpacing: 1.25,
    fontSize: 16
  }
}));
